import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';

export interface ChangePasswordRequest {
  /** 현재 비밀번호 */
  currentPassword: string;
  /** 새 비밀번호 */
  newPassword: string;
}

/**
 * 내 비밀번호 변경
 * @description 현재 로그인한 관리자의 비밀번호를 변경합니다
 * @endpoint PUT /admin/auth/password
 */
export function putMePasswordApi(body: ChangePasswordRequest) {
  return axiosInstance.put<ApiResponse<{ message: string }>>('/admin/auth/password', body);
}
